module.exports = {"440785001":"恩城街道","440785100":"横陂镇","440785101":"圣堂镇","440785102":"良西镇","440785103":"沙湖镇","440785104":"牛江镇","440785105":"君堂镇","440785106":"大田镇","440785107":"那吉镇","440785108":"大槐镇","440785109":"东成镇","440785400":"恩平园区管委会"}


//////////////////
// WEBPACK FOOTER
// ./src/town/440785.json
// module id = 1996
// module chunks = 0